export default "__VITE_ASSET__qFgOzu76__"